<script setup lang="ts">
import type { IFootnote } from "~/models/IFootnote";

defineProps<{
  footnote: IFootnote;
}>();
</script>

<template>
  <a :id="`fnr${footnote.id}`" :href="`#fnanchor${footnote.id}`">
    {{ footnote.text }}
  </a>
</template>
